/**
 * React Query hooks for Friends API
 * Uses TanStack Query for caching, loading states, and error handling
 */

import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../helpers/apiClient.helper';
import { fetchFriends } from '../helpers/friendsApi';

/**
 * Hook to fetch friends list
 * @param userId - User ID to fetch friends for
 * @param enabled - Whether the query should run (default: true)
 */
export const useFriendsQuery = (userId: string, enabled: boolean = true) => {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ['friends', userId],
    queryFn: async () => {
      return fetchFriends(userId, apiClient);
    },
    enabled: enabled && !!userId,
    staleTime: 2 * 60 * 1000, // Friends data refreshes every 2 minutes
    gcTime: 10 * 60 * 1000, // Keep in cache for 10 minutes
  });
};
